import React from 'react';

import homeIcon from '../assets/home.svg';
import { DEFAULT_TABS, type PageNavbarTab, type TabDefinition } from '../types/navbar';

interface PageNavbarProps {
  /** Current experiment name - REQUIRED */
  experimentName: string;

  /** Experiment organism (e.g., 'Mouse', 'Human') - REQUIRED */
  experimentOrganism: string;

  /** Currently active tab - REQUIRED */
  activeTab: PageNavbarTab;

  /** Callback when tab is clicked */
  onTabChange: (tab: PageNavbarTab) => void;

  /** Callback when home icon is clicked */
  onHomeClick: () => void;

  /** Optional: Callback when experiment name is clicked (to toggle sidebar) */
  onExperimentClick?: () => void;

  /** Optional: Callback when search input changes */
  onSearch?: (value: string) => void;

  /** Optional: Custom search placeholder text */
  searchPlaceholder?: string;

  /**
   * Optional: Custom tabs configuration
   * If not provided, uses DEFAULT_TABS from types/navbar.ts
   */
  tabs?: TabDefinition[];
}

export function PageNavbar({
  experimentName,
  experimentOrganism,
  activeTab,
  onTabChange,
  onSearch,
  onHomeClick,
  onExperimentClick,
  searchPlaceholder = 'Search',
  tabs = DEFAULT_TABS,
}: PageNavbarProps) {
  return (
    <div className="toolbar-container">
      {/* Home Icon */}
      <button
        type="button"
        onClick={onHomeClick}
        className="w-7 h-7 flex items-center justify-center hover:opacity-70 transition-opacity flex-shrink-0 bg-transparent border-none outline-none cursor-pointer"
        aria-label="Go to home"
      >
        <img src={homeIcon} alt="Home" width={22} height={20} />
      </button>

      {/* Liquid Glass Pill Container */}
      <div className="glass-container">
        {/* Experiment Name and Type */}
        <div className="flex flex-col gap-0.5 min-w-fit" onClick={onExperimentClick} style={{ cursor: onExperimentClick ? 'pointer' : 'default' }}>
          <span className="text-experiment-name">{experimentName}</span>
          <span className="text-experiment-organism">{experimentOrganism}</span>
        </div>

        {/* Tab Buttons */}
        <nav className="flex items-center gap-6 relative ml-4" role="tablist" aria-label="Experiment sections">
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              role="tab"
              aria-selected={tab.id === activeTab}
              aria-controls={`${tab.id}-panel`}
              className="tab-button"
            >
              <span className={`text-tab-label ${tab.id === activeTab ? 'text-tab-active' : 'text-tab-idle'}`}>{tab.label}</span>

              {/* Green underline for active tab */}
              {tab.id === activeTab && (
                <div className="tab-indicator">
                  <div className="tab-indicator-bar" />
                </div>
              )}
            </button>
          ))}
        </nav>

        {/* Search Bar */}
        {/* <div className="ml-auto flex-shrink-0">
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 border border-neutral-100">
            <input
              type="text"
              placeholder={searchPlaceholder}
              className="w-20 bg-transparent border-none outline-none text-sm text-neutral-700"
              onChange={(event) => onSearch?.(event.currentTarget.value)}
              aria-label="Search"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}
